import { b as getUserCount } from "../../../../../chunks/utils.js";
const load = async () => {
  const userCount = await getUserCount();
  return {
    userCount
  };
};
export {
  load
};
